import React from "react";
import EbDialog from "../../../ExecutionBlueprint/ExecutionBlueprintLiveReview/_shared/EbDialog";
import "../../../ExecutionBlueprint/ExecutionBlueprintReview/InfoDialog.scss";

// The confirmation in front of "Start live review" (§9.5). Starting tells
// every member on the app to join, so it is worth one look first — and the
// gate on finishing (every to-discuss objective discussed) is the thing to
// know before beginning.
const POINTS = [
  "The CEO and the team join you on the same board. You and the CEO can edit; everyone else watches.",
  "Every objective you flagged to discuss has to be marked discussed before the OKRs can be locked.",
  "Locking is final: it ends the session and starts the quarter's tracking.",
];

const StartLiveReviewDialog = ({ starting, onStart, onClose }) => (
  <EbDialog
    isOpen
    size="lg"
    tone="primary"
    icon={<i className="fa-regular fa-circle-play" aria-hidden="true" />}
    title="Start the live review?"
    subtitle="A short session with the CEO and their team to discuss, agree and lock this quarter's OKRs."
    busy={starting}
    onClose={onClose}
    align="between"
    actions={[
      { label: "Go back", variant: "ghost", onClick: onClose },
      {
        label: "Start live review",
        loadingLabel: "Starting…",
        variant: "primary",
        onClick: onStart,
        loading: starting,
      },
    ]}
  >
    <ol className="info-steps">
      {POINTS.map((point) => (
        <li key={point}>{point}</li>
      ))}
    </ol>
  </EbDialog>
);

export default StartLiveReviewDialog;
